import { Component, OnInit } from '@angular/core';
import { NotificationService } from '../../services/notification.service';
import { SharedModule } from '../../shared.module';
import { Router } from '@angular/router';
import { LanguageService } from '../../../../core/modules/translate/services/language.service';
import { Languages } from '../../../../core/enums/languages';

@Component({
  selector: 'app-notification-badge',
  imports: [SharedModule],
  templateUrl: './notification-badge.component.html',
  styleUrls: ['./notification-badge.component.scss']
})
export class NotificationBadgeComponent implements OnInit {
  newChatAssigned = this.notificationService.newChatAssigned;
  unreadMessageCount = this.notificationService.unreadMessageCount;
  showMessageNotification = this.notificationService.showMessageNotification;
  messagePreview = this.notificationService.messagePreview;
  projectName = this.notificationService.projectName;
  isClient = this.notificationService.isClient;

  constructor(
    protected notificationService: NotificationService,
    private router: Router,) { }

  ngOnInit() {
  }
  handleChatAssignmentClick() {
    this.router.navigate(['/chat']);
    this.notificationService.clearNewChatNotification();
  }
  handleMessageNotificationClick() {
    this.router.navigate(['/chat']);
    this.notificationService.resetUnreadMessageCount();
  }

}
